module.exports = __webpack_public_path__ + "static/media/sitting_bilateral_functional_reach.34ce2ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/sitting_bilateral_functional_reach.png
// module id = 714
// module chunks = 0